import { NotificationItem } from './notification-item';

export enum NotificationDateGroupType {
    Today,
    Yesterday,
    Older,
    Latest
}

export interface NotificationDateGroup {
    type: NotificationDateGroupType;
    items: NotificationItem[];
}